import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm$items;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.LandingPartnersSection
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.inner
  }, [_c('div', {
    class: _vm.$style.count,
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.description,
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.bottom
  }, [_c('div', {
    class: _vm.$style.text
  }, [_c('span', [_vm._v("\n            Наши\n          ")]), _vm._v(" "), _c('span', [_vm._v("\n            партнёры\n          ")])]), _vm._v(" "), (_vm$items = _vm.items) !== null && _vm$items !== void 0 && _vm$items.length ? _c(_setup.LandingPartnerSlider, {
    attrs: {
      "items": _vm.items
    }
  }) : _vm._e()], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };